import axios from 'axios';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const fetchClient = () => {

  let baseUrl = 'https://api.eaterpad.com/';
  if(false) {
    baseUrl = 'http://localhost:3090/';
  }

  const defaultOptions = {
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json'
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // instance.interceptors.request.use(request => {
  //   console.log('Starting Request', request)
  //   return request
  // })
  //
  // instance.interceptors.response.use(response => {
  //   console.log('Response:', response)
  //   return response
  // })

  // Set the AUTH token for any request
  instance.interceptors.request.use(async function (config) {
    const token = cookies.get('jwt_token');

    config.headers.Authorization =  token ? `${token}` : '';
    return config;
  });

  return instance;
};

export default fetchClient();
